module.exports = __webpack_public_path__ + "static/media/201CS208.72da5cad.jpg";